var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled/Eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "IconVector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11815 9.10736C2.70231 7.48171 4.67959 3.54199 9.99982 3.54199C15.3201 3.54199 17.2973 7.48171 17.8815 9.10737C18.0898 9.6871 18.0898 10.3136 17.8815 10.8933C17.2973 12.5189 15.3201 16.4587 9.99982 16.4587C4.67959 16.4587 2.70231 12.5189 2.11815 10.8933C1.90983 10.3136 1.90983 9.6871 2.11815 9.10736ZM9.99984 12.5003C11.3805 12.5003 12.4998 11.381 12.4998 10.0003C12.4998 8.61961 11.3805 7.50033 9.99984 7.50033C8.61913 7.50033 7.49984 8.61961 7.49984 10.0003C7.49984 11.381 8.61913 12.5003 9.99984 12.5003Z",
    fill: "#033272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.97a80a77d4732b09227c9bedcdfa3bb2.svg";
export { ForwardRef as ReactComponent };